import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";
import "react-calendar-timeline/lib/Timeline.css";
import GuestHeader from "../../../Layout/Guest/Header";
import { FaCar, FaParking, FaPlus } from "react-icons/fa";
import WeeklyTimelineScheduler from "../../../Components/WeeklyTimeS";
import CustomScrollbar from "../../../Components/CustomScrollbar/CustomScrollbar";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB, srLatn } from "date-fns/locale";
import { format } from "date-fns";
import GuestReservationModal from "../../../Components/Modals/GuestReservationModal";
import EditModal from "../../../Components/Modals/EditReservationModal";
import apiRequest from "../../../api";
import "../../pages.css";
import moment from "moment";

const GuestParking = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedLanguageRef = useRef(localStorage.getItem('Language') || 'RS'); // Default to Serbian for guests

  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
      const translationMap = {
            "Manager (max 44)": "Manager (max 44)",
            "Theater (max 56)": "Theater (max 56)",
            "Menadžerska (max 44)": "Manager (max 44)",
            "Bioskopska (max 56)": "Theater (max 56)",
            "Training": "Trening",
            "Trening": "Training",
            "Custom": "Prilagođeno",
            "Prilagođeno": "Custom",
      };
      setItems(prevData =>
        prevData.map(item => ({
          ...item,
          seats: translationMap[item.seats]
        })));
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  // Check for URL parameters on component mount
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      const dateParam = searchParams.get('date');
      console.log('Guest - Date param from URL:', dateParam); // Debug log

      if (dateParam) {
        let date;

        // Support both ISO format (YYYY-MM-DD) and DD/MM/YYYY format
        if (dateParam.includes('-')) {
          // ISO format YYYY-MM-DD
          date = new Date(dateParam);
          console.log('Guest - Parsed ISO date:', date); // Debug log
        } else if (dateParam.includes('/')) {
          // DD/MM/YYYY format (legacy support)
          const parts = dateParam.split('/');
          if (parts.length === 3) {
            const [day, month, year] = parts;
            date = new Date(year, month - 1, day);
            console.log('Guest - Parsed DD/MM/YYYY date:', date); // Debug log
          }
        }

        if (date && !isNaN(date.getTime())) {
          console.log('Guest - Setting selected date to:', date); // Debug log
          setSelectedDate(date);
          await fetchReservations(date);
          setLoading(false);
          return; // Exit early since we found a valid date
        } else {
          console.log('Guest - Invalid date, using current date'); // Debug log
        }
      } else {
        console.log('Guest - No date param found'); // Debug log
      }

      // If no valid date parameter, fetch reservations for current date
      await fetchReservations();
      setLoading(false);
    };

    loadData();
  }, [searchParams]);

  const locale = selectedLanguageRef.current === 'RS' ? srLatn : enGB;
  const calendarRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [isMainCalendarOpen, setIsMainCalendarOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null);

  const handleSelect = (date) => {
    setSelectedDate(date);
    setIsMainCalendarOpen(false); // Close the calendar after selecting a date

    // Update URL parameter with ISO format (YYYY-MM-DD)
    const formattedDate = format(date, "yyyy-MM-dd");
    console.log('Guest - Updating URL with date:', formattedDate); // Debug log
    setSearchParams({ date: formattedDate });

    fetchReservations(date);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const [selectedRow, setSelectedRow] = useState({
    start_time: new Date(),
    end_time: new Date(),
    name: "",
    username: "",
    seats: "",
    notes: "",
    id: "",
  });
  const toggleEditModal = (row) => {
    if (editModal === true) {
      // Close modal, no need for additional action when closing
      setEditModal(false);
    } else {
      setSelectedRow(row);
      setEditModal(true);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) // Check if click is outside
      ) {
        setIsMainCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchReservations = async (date = selectedDate) => {
    const formatDateToLocal = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    };
    try {
      // No JWT token needed for guest view - this would need to be adjusted to call a public API
      const formattedDate = formatDateToLocal(date);
      console.log("Guest - Usao u fetch", date, formattedDate);

      // For now, use the same API but without authentication
      // In production, you'd want a separate public API endpoint
      const reservations = await apiRequest(`/api/reservations/get_all_weekly_reservations?date=${formattedDate}`, 'GET', null, null);
      console.log("Guest - API response", reservations);
      const translationMap = {
        "Manager (max 44)": "Menadžerska (max 44)",
        "Theater (max 56)": "Bioskopska (max 56)",
        "Training": "Trening",
        "Custom": "Prilagođeno",
      };

      const formattedData = reservations.map((reservation) => {
        const startDate = new Date(reservation.startTime);
        const endDate = new Date(reservation.endTime);

        return {
          id: reservation.reservationCode,
          username: reservation.username,
          start_time: startDate,
          end_time: endDate,
          name: reservation.name,
          notes: reservation.notes,
          seats: selectedLanguageRef.current === 'RS' ? translationMap[reservation.seats] : reservation.seats,
        };
      });

      setItems(formattedData);
      console.log("Guest - Items:", formattedData);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <GuestHeader />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <GuestHeader />
      <Container className="app-container">
        <Row className="my-3">
          <Col xs="8" sm="6" md="9" className="text-start  d-flex align-items-center justify-content-start  justify-content-md-start  ">
            <div className=" form-group position-relative date_input" ref={calendarRef} >

              <img
                src="/assets/icons/calendarDay.svg"
                alt="Calendar Icon"
                className="calendar-icon"
              />
              <input
                type="text"
                className="form-control custom-input"
                value={format(selectedDate, "dd.MM.yyyy")} // Display the selected date
                onClick={() => setIsMainCalendarOpen(!isMainCalendarOpen)} // Toggle calendar visibility
                readOnly
                style={{ cursor: "pointer" }}
              />


              {isMainCalendarOpen && (
                  <Calendar
                    date={selectedDate}
                    onChange={handleSelect}
                    locale={locale} // Set the locale
                    color="rgba(13, 114, 72, 0.4)"
                    className="calendar-container"
                  />
              )}
            </div>
          </Col>
          <Col

            xs="4"
            sm="6"
            md="3"

            className="text-end d-flex  justify-content-end"
          >
            <div className=' text-end btn-container d-flex justify-content-end justify-content-md-end '   >
              <Button className='add-btn' onClick={toggleModal} > <div className='plus'>+</div> </Button>
            </div>
          </Col>
        </Row>

        <Row className="app-container g-0">
          <Col style={{ margin: "0", padding: "0" }}>
            <WeeklyTimelineScheduler onEdit={(row) => toggleEditModal(row)} fetchReservations={() => fetchReservations()} items={items} selectedDate={selectedDate} />
          </Col>
        </Row>


      </Container>
      <GuestReservationModal
        isOpen={modalOpen}
        toggle={toggleModal}
        fetchReservations={fetchReservations}
        selectedDate={selectedDate}
      />

      <EditModal
        isOpen={editModal}
        toggle={toggleEditModal}
        selectedRow={selectedRow}
        fetchReservations={fetchReservations}
      />
    </>
  );
};

export default GuestParking;